<template>
  <div @submit.prevent="submitForm">
    <h2>Enrol Others Or A Group</h2>

    <form class="tdesk-form">
      <div v-if="isReadOnly" class="tdesk-primary-notice info">
        <i class="fal" aria-hidden="true" />
        Your information is locked to the account your currently logged in with
      </div>
      <form-errors :errors="formErrors" />

      <div class="form-group required col-md-8">
        <label for="first-name">First Name</label>
        <input
          id="organizer-first-name-input"
          v-model="localOrganizer.first_name"
          type="text"
          required
          :readonly="isReadOnly"
        >
      </div>
      <div class="form-group required col-md-8">
        <label for="last-name">Last Name</label>
        <input
          id="organizer-last-name-input"
          v-model="localOrganizer.last_name"
          type="text"
          required
          :readonly="isReadOnly"
        >
      </div>
      <div class="form-group required col-md-8">
        <label for="mobile-number">Mobile Number</label>
        <input
          id="organizer-mobile-number-input"
          v-model="localOrganizer.mobile_number"
          type="tel"
          required
          :readonly="isReadOnly"
        >
      </div>
      <div class="form-group required col-md-10">
        <label for="e-mail">E-Mail</label>
        <input
          id="organizer-email-input"
          v-model="localOrganizer.email"
          type="email"
          required
          :readonly="isReadOnly"
        >
      </div>
      <div class="form-group checkbox col-md-12">
        <input
          id="organizer-enrolling-self-input"
          v-model="localOrganizer.enrolling_self"
          type="checkbox"
        >
        <label class="control-label" for="enrolling-self-input">I will be participating in the course as a student</label>
      </div>

      <div class="col-md-12">
        <button id="submit-organizer-details" class="tdesk-secondary-button" type="submit">
          <i class="fas fa-caret-right" />
          Next
        </button>
      </div>
    </form>
  </div>
</template>
<script>

import FormErrors from "../../../components/form_errors.vue";
import {getEligibilityCheckPath} from "./helpers/courseEligibility";

export default {
  components: {FormErrors},
  props: {
    organizer: {type: Object, required: true },
    courseId: { type: Number, required: true },
    partnerId: { type: Number, required: false, default: null },
    phoneNumberRegex: { type: String, required: true },
    isPartnerCourse: { type: Boolean, required: true },
  },

  data() {
    return {
      localOrganizer: { ...this.organizer },
      formErrors: [],
    };
  },

  computed: {
    isReadOnly() {
      return this.organizer.existing_account;
    },
  },

  watch: {
    organizer: {
      handler(newValue) {
        this.localOrganizer = { ...newValue };
      },
      deep: true,
    },
  },

  methods: {
    submitForm() {
      if (!this.isReadOnly && !this.validMobileNumber()) {
        this.formErrors = ['Mobile number does not have correct format (ex. 0412345678)'];
        return;
      }

      if (this.localOrganizer.enrolling_self) {
        this.checkUserEligibility();
      } else {
        this.finalizeSubmission();
      }
    },

    validMobileNumber() {
      const regex = new RegExp(this.phoneNumberRegex);
      return regex.test(this.localOrganizer.mobile_number);
    },

    checkUserEligibility() {
      const currentUrlParams = new URLSearchParams(window.location.search);
      // cid needed as this is how admin lms courses map to a course as opposed to /course_id/
      const cid = currentUrlParams.get('cid');
      const paramsObj = {
        email: this.localOrganizer.email,
        first_name: this.localOrganizer.first_name,
        last_name: this.localOrganizer.last_name,
        cid: cid,
        lms_course_id: this.courseId,
        partner_id: this.partnerId,
      };
      const eligibilityCheckPath = getEligibilityCheckPath({isPartnerCourse: this.isPartnerCourse, params: paramsObj});

      $.ajax({
        url: eligibilityCheckPath,
        type: 'GET',
        dataType: 'json',
        contentType: 'application/json',
        success: function(response) {
          if (response.eligible) {
            this.finalizeSubmission();
          } else {
            this.formErrors = [response.error_message];

            if (response.error_type === 'incorrect_name_details') {
              this.localOrganizer.first_name = response.user_details.first_name;
              this.localOrganizer.last_name =  response.user_details.last_name;
            }
          }
        }.bind(this),
        error: function() {
          this.formErrors = ['An error occurred. Please try again or contact support if this issue persists'];
        }.bind(this),
      });
    },

    finalizeSubmission() {
      this.localOrganizer.details_confirmed = true;
      this.$emit("update-organizer", this.localOrganizer);
    },
  },
};
</script>
